/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import PatchAddress from "App/utils/globe/chunk_lod/patch_address";

export default
class ModelAddress extends PatchAddress {

    private _dataDirectoryName: string;

    constructor(aValues: any) {
        super(aValues);

        this._dataDirectoryName = "octreeData"; // TODO: it could be quadtreeData as well //aValues.dataDirectoryName;
    }

    public create(aValues: any): ModelAddress {
        return new ModelAddress(aValues);
    }

    public toLevel(aLevel: number): ModelAddress {
        if (this.level >= aLevel) {
            return new ModelAddress({
                    layer: Math.floor(this.layer / Math.pow(2, this.level - aLevel)),
                    row: Math.floor(this.row / Math.pow(2, this.level - aLevel)),
                    col: Math.floor(this.col / Math.pow(2, this.level - aLevel)),
                    level: aLevel
                }
            );
        } else {
            return new ModelAddress({
                    layer: this.layer * Math.pow(2, aLevel - this.level),
                    row: this.row * Math.pow(2, aLevel - this.level),
                    col: this.col * Math.pow(2, aLevel - this.level),
                    level: aLevel
                }
            );
        }
    }

    public generateUID(): string {
        return this.patchInfo.name + "-" + this.level + "-" + this.layer + "-" + this.row + "-" + this.col;
    }

    public getDataUrl(): string {
        return this.getBaseURL() + this._dataDirectoryName + "/" + this.level + "-" + this.layer + "-" + this.row + "-" + this.col + ".dat";
    }

    public getDataBaseUrl(): string {
        return this.base + this._dataDirectoryName + "/";
    }

    public getBaseURL(): string {
        if (this.base.indexOf("://") !== -1) {
            return this.base + this.patchInfo.name;
        } else if (this.base.indexOf("./") === 0) {
            return this.origin + this.base.substring(1);
        } else {
            return this.origin + this.base;
        }
    }
}
